import { Link } from 'react-router-dom'
import { formatMs } from '../utils/time'
import moment from 'moment'

// helper: milisegundos desde medianoche -> moment
const parseMsToMoment = (fechaYYYYMMDD, ms) => {
  const base = moment(fechaYYYYMMDD, 'YYYY-MM-DD');
  if (!base.isValid()) return null;
  const n = Number(ms);
  return Number.isFinite(n)
    ? base.startOf('day').add(n, 'ms')
    : base; // si no hay ms, devolvemos 00:00 del día
};

const CompeticionList = (props) => {
  return (
    <div>
      {/* Título del evento */}
      {props.eventoNombre && (
        <div className="text-center mb-6">
          <div className="text-2xl font-montserrat font-semibold italic text-white leading-tight">
            {props.eventoNombre}
          </div>
        </div>
      )}

      {/* Lista de competiciones */}
      <ul className="space-y-4 list-none m-0">
        {props.competiciones.map(competicion => {

          // Fechas base (usando ms desde medianoche)
          const fechaInicio = competicion.fecha_inicio
            ? parseMsToMoment(competicion.fecha_inicio, competicion.hora_inicio ?? 0)
            : null;

          // Si hay hora_fin (ms) la usamos; si no, usamos fin del día de inicio
          const fechaFin = competicion.fecha_inicio
            ? (competicion.hora_fin != null
                ? parseMsToMoment(competicion.fecha_inicio, competicion.hora_fin)
                : (fechaInicio ? moment(fechaInicio).endOf('day') : null))
            : null;

          // Momento actual
          const ahora = moment();
          // Verificar estados
          const esHoy = fechaInicio ? ahora.isSame(fechaInicio, 'day') : false;
          const haEmpezado = fechaInicio ? ahora.isAfter(fechaInicio) : false;
          
          const haFinalizado = Boolean(competicion.carrera_finalizada);

          // Badge según estado
          let estadoBadge = { texto: 'Próximo', clase: 'bg-blue-100 text-blue-700' };

          if (haFinalizado) {
            estadoBadge = { texto: 'Finalizado', clase: 'bg-gray-100 text-gray-700' };
          } else if (haEmpezado) {
            estadoBadge = { texto: 'En vivo', clase: 'bg-green-100 text-green-700' };
          } else if (esHoy) {
            estadoBadge = { texto: 'Hoy', clase: 'bg-yellow-100 text-yellow-800' };
          }

          return (
            <li
              key={competicion.id}
              className="bg-white rounded-lg shadow-md hover:shadow-xl hover:scale-[1.01] transition-all duration-300 border-l-3 border-ccnorte"
            >
              <Link to={`/competicion/${competicion.id}`} className="block p-4 relative">
                {/* Nombre de la competición */}
                <div className="text-lg font-montserrat font-semibold italic text-gray-900 mb-4 leading-tight">
                  {competicion.nombre}
                </div>

                {/* Hora de salida */}
                <div className="flex items-center gap-3">
                  <span className={`px-3 py-1 ${estadoBadge.clase} font-montserrat font-light text-xs rounded-full uppercase flex items-center gap-1`}>
                    {estadoBadge.texto === 'En vivo' && (
                      <span className="animate-[pulse_0.8s_ease-in-out_infinite]">●</span>
                    )}
                    {estadoBadge.texto}
                  </span>
                  <span className="text-sm text-gray-600 font-medium font-montserrat">
                    {/* formatMs ya recibe ms, así que lo mantenemos */}
                    Salida a las <strong>{formatMs(competicion.hora_inicio)}</strong>
                  </span>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CompeticionList;
